import { mapState } from 'vuex'

export default {
	data() {
		return {
			loading: false,
		}
	},
	computed: {
		...mapState({
			player: (state) => state.player.player,
			onHoldWallet: (state) => state.player.onHoldWallet,
			totalBalanceLoading: (state) => state.player.totalBalanceLoading,
		}),
		disableTransferToWallet() {
			return this.onHoldWallet === 0
		},
	},
	methods: {
		async transferOnHoldWallet() {
			this.loading = true
			const result = await this.$store.dispatch(
				'player/playerWalletsTransfer'
			)
			this.loading = false
			if (result) {
				this.fetchTotalBalance()
			}
		},
		async fetchTotalBalance() {
			await this.$store.dispatch('player/profile')
			await this.$store.dispatch('player/totalBalance')
		},
	},
}